import { connect, useDispatch } from "react-redux";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { IStudentQuickLinks } from "../../../../../models/student/studentCourceDetail";
import { useEffect } from "react";
import { setWidgets } from "../../../../../store/slices/master/widgetSlice";
import { getWidgets } from "../../../../../action/masters/widgetActionCreator";
import { IWidgets } from "../../../../../models/master/widgets";

const QuickLinkViewAll = (props: IStudentQuickLinks) => {
  const { getAllWidgets, widgets } = props;

  useEffect(() => {
    getAllWidgets(pageBlockId.quickLinks, undefined);
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  return (
    <div className="widgets">
      <div className="title">
        <h2>All Quick Links</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {widgets.map((widget: IWidgets) => (
            <div className="col-md-12 mb-3" key={widget.id}>
              <div className="resourcecard icon-visibility">
                <a href={widget.url} target="_blank" className="h-100">
                  <div className="img">
                    <img src="/assets/images/apps/learninghub.svg" alt="" />
                  </div>
                  <div className="dtls">
                    <h3 className="para-hide-1">{widget.name}</h3>
                    <p className="para-hide-2">{widget.description}</p>
                  </div>
                  <span>
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getAllWidgets: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinkViewAll);
